import type { FC } from 'react';

export const ScoreBadge: FC<
	React.HTMLAttributes<HTMLDivElement> & {
		children?: React.ReactNode;
	}
> = (props) => {
	return (
		<div className="w-fit px-3 py-1 text-sm skin-bg-badge skin-text-badge skin-rounded-full" {...props}>
			{props.children}
		</div>
	);
};
